<ng-content *ngIf="(mode$ | async) === viewEditMode.view" select="[view]"></ng-content>
<ng-content *ngIf="(mode$ | async) === viewEditMode.edit" select="[edit]"></ng-content>
